import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './CustomAIDimension.css';
import { Icon } from '../../components/widgets';
import { IconSizes, IconVariants } from '../../components/foundations/Icon';
import EditableTitle from '../../components/widgets/EditableTitle';
import Badge, { BadgeVariants } from '../../components/atoms/Badge';
import { FORM_TRANSLATIONS } from '../consts';

const CustomAIDimensionHeader = ({ customAIDimension, onDelete, onNameChange, isExpanded }) => {
    const isNew = !customAIDimension.id;
    const displayName = customAIDimension.display_name || '';
    const showHookBadge = !isExpanded && customAIDimension.hook_enabled;

    return (
        <div className={css.header}>
            <div className={css.titleRow}>
                {!isExpanded ? (
                    <span className={css.displayName}>{displayName}</span>
                ) : (
                    <EditableTitle
                        value={displayName}
                        placeholder="e.g. Discount Display"
                        onTextChanged={onNameChange}
                    />
                )}
                {showHookBadge && (
                    <Badge variant={BadgeVariants.INDIGO} className={css.hookTagBadge}>
                        <Translate
                            id={FORM_TRANSLATIONS.HOOK_TAG_BADGE}
                            data={{ duration: customAIDimension.hook_duration }}
                        />
                    </Badge>
                )}
            </div>
            {!isNew && (
                <Icon
                    name="trash"
                    size={IconSizes.SMALL}
                    variant={IconVariants.LIGHT}
                    onClick={e => {
                        e.stopPropagation();
                        onDelete();
                    }}
                />
            )}
        </div>
    );
};

CustomAIDimensionHeader.propTypes = {
    customAIDimension: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        app: PropTypes.string,
        description: PropTypes.string,
        display_name: PropTypes.string,
        media_type: PropTypes.number,
        valueType: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.string),
        hook_enabled: PropTypes.bool,
        hook_duration: PropTypes.number,
    }),
    onDelete: PropTypes.func,
    onNameChange: PropTypes.func,
    isExpanded: PropTypes.bool,
};

export default CustomAIDimensionHeader;
